import React from 'react'
import clsx from 'clsx'
import ContactSalesButton from '~/molecules/Billing/ContactSalesButton'

export default function ChangePlanSummaryPanel({ selectedPlanData, seats, estimate, estimateLoading, subscription, onContactSales, showContactSales = true, simplified = false, className = '' }) {
  const hasAdjustment = !!estimate?.adjustment

  return (
    <div className={clsx('w-78 shrink-0 px-6 pb-6 lg:pt-6 flex flex-col overflow-y-auto', className)}>
      <p className='text-base pb-2 font-bold text-llama-grey-7'>Summary</p>

      <div className='px-4 py-6 border border-neutral-200 rounded-lg overflow-hidden text-llama-grey-7'>

        {/* Header: Selected plan */}
        <div className='pb-4'>
          <p className='text-base font-bold text-llama-grey-7'>
            Selected plan: {selectedPlanData?.name ?? '—'}
          </p>
        </div>

        <div className='border-t border-llama-grey-8' />

        {estimateLoading ? (
          <div className='py-6 space-y-3 animate-pulse'>
            {(simplified ? [1] : [1, 2, 3, 4, 5]).map((i) => (
              <div key={i} className='flex justify-between items-center'>
                <div className='h-3 bg-neutral-200 rounded w-28' />
                <div className='h-3 bg-neutral-200 rounded w-14' />
              </div>
            ))}
          </div>
        ) : (
          <>
            {!simplified && (
              <>
                {/* Core plan section: 16px top, 8px bottom */}
                <div className='pt-4 pb-2'>
                  <p className='text-sm font-bold text-llama-grey-7 pb-1'>{selectedPlanData?.name} plan</p>
                  <div className='flex justify-between items-center'>
                    <span className='text-sm font-semibold text-llama-grey-7'>
                      {seats} seats × {estimate?.license_cost ?? '—'}
                    </span>
                    <span className='text-sm font-bold text-llama-grey-7 lining-nums'>
                      {estimate?.annual_price ?? '—'}
                    </span>
                  </div>
                </div>

                {/* Adjustment section: 4px bottom per row */}
                {hasAdjustment && (
                  <div className='pb-2'>
                    <div className='flex justify-between items-center h-10'>
                      <span className='text-sm font-semibold text-llama-grey-7'>Adjustments</span>
                      <span className='text-sm font-bold text-llama-grey-7 lining-nums'>{estimate.adjustment}</span>
                    </div>
                  </div>
                )}

                <div className='border-t border-llama-grey-8' />
              </>
            )}

            {/* Total due today */}
            <div className='pt-4 flex justify-between items-center'>
              <span className='text-lg font-bold text-llama-grey-7'>Total due today</span>
              <span className='text-lg font-bold text-llama-grey-7 lining-nums'>
                {estimate?.total_due_today ?? '—'}
              </span>
            </div>
          </>
        )}
      </div>

      {showContactSales && (
        <div>
          <p className='text-sm font-bold text-llama-grey-7 mb-2 mt-4'>
            Questions about your plan or billing?
          </p>
          <ContactSalesButton size='sm' onClick={onContactSales} />
        </div>
      )}
    </div>
  )
}
